import { drizzle } from "drizzle-orm/mysql2";
import mysql from "mysql2/promise";
import { env } from "../lib/env";
import * as schema from "./schema/index";

/**
 * Single shared MariaDB connection pool + Drizzle instance.
 * MariaDB is MySQL-compatible, so we use the mysql2 driver (reskin-docs/01 §2).
 * Every tenant query must still be company-scoped at the query layer (reskin-docs/07 §1).
 */
export const pool = mysql.createPool({
  uri: env.DATABASE_URL,
  // Keep the pool lean — CloudLinux LVE caps per-account processes/RAM (reskin-docs/01 §6).
  connectionLimit: 10,
  enableKeepAlive: true,
});

export const db = drizzle(pool, { schema, mode: "default" });

export type DB = typeof db;
export { schema };
